import React from 'react'

function PhotoGallery() {
  return (
    <div>PhotoGallery</div>
  )
}

export default PhotoGallery